import * as API from "./httpService"
import * as CommonFunction from "../common/function"
import {
  updateUiData,
  updateDropdown,
  updateFromGetData,
  updateClaimDataProperty,
} from "../redux/actions"
import {
  policyValidationAlert,
  insuredValidationAlert,
} from "../services/sweetalertService"

export function GetPolicyInfo(policyInfo) {
  return dispatch =>
    API.apiPostRequest("/Claim/LifePolicyInfo", policyInfo, null)
      .then(response => {
        const { UpStatus, IsValidPolicy, ProductType } = response.data
        if (UpStatus.toLowerCase() === "true" && IsValidPolicy === "Y") {
          dispatch(updateFromGetData("productType", ProductType))
          dispatch(
            updateClaimDataProperty("claimAttributeModel", "UpStatus", UpStatus)
          )
          dispatch(updateUiData("showLoading", false))
          dispatch(updateUiData("maxPageNumber", 3))
          CommonFunction.navigateToSupportingDocument()
        } else if (UpStatus.toLowerCase() === "true" && IsValidPolicy === "N") {
          dispatch(updateUiData("showLoading", false))
          policyValidationAlert()
        } else {
          dispatch(
            updateClaimDataProperty("claimAttributeModel", "UpStatus", "False")
          )
          dispatch(updateUiData("showLoading", false))
          dispatch(updateUiData("maxPageNumber", 3))
          CommonFunction.navigateToSupportingDocument()
        }
      })
      .catch(error => {
        dispatch(
          updateClaimDataProperty("claimAttributeModel", "UpStatus", "False")
        )
        dispatch(updateUiData("showLoading", false))
        dispatch(updateUiData("maxPageNumber", 3))
        CommonFunction.navigateToSupportingDocument()
      })
}

export function GetInsuredInfo(upStatus, policyNumber, NRIC, insuredName, DOB) {
  return dispatch =>
    API.apiPostRequest(
      "/Claim/LifeInsuredInfo",
      {
        policyNumber: policyNumber,
        NRIC: NRIC,
        InsuredName: insuredName,
        DOB: DOB,
      },
      null
    )
      .then(response => {
        const { IsValidInsured } = response.data

        if (IsValidInsured === "Y" && upStatus.toLowerCase() === "true") {
          dispatch(updateUiData("showLoading", false))
          dispatch(updateUiData("maxPageNumber", 5))
          CommonFunction.navigateToClaimantDetail()
        } else if (
          IsValidInsured === "N" &&
          upStatus.toLowerCase() === "true"
        ) {
          dispatch(updateUiData("showLoading", false))
          insuredValidationAlert()
        } else {
          dispatch(updateUiData("showLoading", false))
          dispatch(updateUiData("maxPageNumber", 5))
          CommonFunction.navigateToClaimantDetail()
        }
      })
      .catch(error => {
        dispatch(updateUiData("showLoading", false))
        dispatch(updateUiData("maxPageNumber", 5))
        CommonFunction.navigateToClaimantDetail()
      })
}

export function GetRequiredDocuments(coverageDetailId) {
  return dispatch =>
    API.apiPostRequest(
      "/Claim/GetRequiredDocumentList",
      {
        coverageId: coverageDetailId,
      },
      null
    )
      .then(response => {
        dispatch(updateUiData("proofDocuments", response.data))
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function GetDropdownData(tableName) {
  return dispatch =>
    API.apiPostRequest("/Claim/CommonDropDownList", null, {
      params: {
        name: tableName,
      },
    })
      .then(response =>
        dispatch(
          updateDropdown(response.data.TableName, response.data.CodeTables)
        )
      )
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function SubmitClaim(claimData, uiData) {
  var submitData = claimData

  submitData.claimLifeDetailModel.declaration = uiData.checkBoxStatus.isAgree

  submitData.claimLifeDetailModel.policyHolderName =
    submitData.claimLifeDeceasedModel.deceasedName

  submitData.claimLifeDetailModel.claimantDOB = CommonFunction.combineDateAndTime(
    CommonFunction.convertTextDateToDateTime(
      submitData.claimLifeDetailModel.claimantDOB
    ),
    "00:00"
  )

  submitData.claimLifeDetailModel.deathDate = CommonFunction.combineDateAndTime(
    submitData.claimLifeDetailModel.deathDate,
    submitData.claimLifeDetailModel.deathTime
  )

  // Pass first page data into [claimLifeDeceasedModel]
  submitData.claimLifeDeceasedModel.isDeceasedEmployed =
    submitData.claimLifeEmployerModel.isDeceasedEmployed
  submitData.claimLifeDeceasedModel.deceasedName =
    submitData.claimLifeDetailModel.deceasedName
  submitData.claimLifeDeceasedModel.NRIC = submitData.claimLifeDetailModel.NRIC
  submitData.claimLifeDeceasedModel.DOB = CommonFunction.combineDateAndTime(
    CommonFunction.convertTextDateToDateTime(
      submitData.claimLifeDetailModel.DOB
    ),
    "00:00"
  )

  if (submitData.claimLifeEmployerModel.employmentDate) {
    submitData.claimLifeEmployerModel.employmentDate = CommonFunction.combineDateAndTime(
      CommonFunction.convertTextDateToDateTime(
        submitData.claimLifeEmployerModel.employmentDate
      ),
      "00:00"
    )
  }

  if (submitData.claimPayoutModel.bankName === "Other") {
    submitData.claimPayoutModel.bankName =
      submitData.claimPayoutModel.otherBankName
  }

  let otherPolicyList = []

  // Assign time 00:00 to every commencementDate
  submitData.claimLifeOtherPolicyListModel.forEach(item => {
    otherPolicyList.push({
      index: item.index,
      companyName: item.companyName,
      commencementDate: CommonFunction.combineDateAndTime(
        new Date(item.commencementDate),
        "00:00"
      ),
      coverageType: item.coverageType,
      sumAssured: item.sumAssured,
    })
  })

  return dispatch =>
    API.apiPostRequest(
      "/Claim/LifeSubmitClaim",
      {
        claimHeaderModel: submitData.claimLifeDetailModel,
        claimLifeDetailModel: submitData.claimLifeDetailModel,
        claimLifeDeceasedModel: submitData.claimLifeDeceasedModel,
        claimLifeEmployerModel: submitData.claimLifeEmployerModel,
        claimLifePhysicianListModel: submitData.claimLifePhysicianListModel,
        claimLifeOtherPolicyListModel: otherPolicyList,
        claimPayoutModel: submitData.claimPayoutModel,
        claimUploadListModel: uiData.claimUploadListModel,
        folderName: uiData.folderName,
        sessionId: "",
      },
      null
    )
      .then(submitClaimResponse => {
        dispatch(
          updateUiData(
            "submittedClaimID",
            submitClaimResponse.data.ClaimRequestNumber
          )
        )
        CommonFunction.navigateToSubmittedClaim()
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function GetBankListData() {
  return dispatch =>
    API.apiPostRequest("/Claim/BankList", null, null)
      .then(response => {
        // Add an empty slection in banklist
        // const emptyBank = {
        //   Bank_Id: 0,
        //   Bank_Name: "",
        //   BIC: "",
        //   IsValid: true,
        //   RegexValidation: "",
        //   RegexValidationJs: "",
        //   ErrorMessage: "",
        // }
        const otherBank = {
          Bank_Id: 0,
          Bank_Name: "Other",
          BIC: "",
          IsValid: true,
          RegexValidation: "",
          RegexValidationJs: "",
          ErrorMessage: "",
        }

        let banklistResult = null
        banklistResult = response.data ? response.data : []

        if (response.data) {
          banklistResult = response.data.concat([otherBank])
        }
        // else {
        //   banklistResult = emptyBank
        // }

        dispatch(updateUiData("bankList", banklistResult))

        dispatch(updateUiData("maxPageNumber", 9))
        CommonFunction.navigateToPaymentDetail()
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}
